import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
  button: {
    width: "217px"
  },
}))

export default useStyles
